
import { defineComponent } from 'vue';
import APIKeyComp from '@/components/global-config/open-weather-map/APIKey.vue';

export default defineComponent({
  components: { APIKeyComp },
});
